import { KeyType } from './CustomKeyboard'
import Key from './Key'
import KeyRow from './KeyRow'
import KeySpecial from './KeySpecial'

export const KEY_HEIGHT = 75
export const KEY_WIDTH = 94
export const SPECIAL_KEY_WIDTH = 125
export const ICON_SIZE = 36
export const STROKE_WIDTH = 2.5
export const SIMPLE_KEY_ROW_COLS = 4
export const SPECIAL_KEY_ROW_COLS = 3

export const kbLayout = [
  ['a', 'b', 'c', 'd'],
  ['e', 'f', 'g', 'h'],
  ['i', 'j', 'k', 'l'],
  ['m', 'n', 'o', 'p'],
  ['q', 'r', 's', 't'],
  ['u', 'v', 'w', 'x'],
  ['y', 'z', '0', '1'],
  ['2', '3', '4', '5'],
  ['6', '7', '8', '9'],
  [
    {
      action: 'space',
      route: 'icon-space',
      speechText: 'Space',
    },
    {
      action: 'backspace',
      route: 'icon-backspace',
      speechText: 'Backspace',
    },
    {
      action: 'trash',
      route: 'icon-trash',
      speechText: 'Delete All',
    },
  ],
]

export const createKey = (key: KeyType, index: number, rowIndex: number) => {
  if (typeof key === 'string') {
    return {
      type: Key,
      rowIndex,
      index,
      key,
      x: KEY_WIDTH * index + STROKE_WIDTH,
    }
  } else {
    return {
      type: KeySpecial,
      rowIndex,
      index,
      key,
      x: SPECIAL_KEY_WIDTH * index + STROKE_WIDTH,
    }
  }
}

export const createKbLayout = () => {
  return kbLayout.map((row, index) => {
    return {
      type: KeyRow,
      index,
      keys: row,
      y: KEY_HEIGHT * index + STROKE_WIDTH,
    }
  })
}
